import React, {Component} from "react";
import classes from './MyApps.module.css';
import {
	Button, Card, CardActionArea, CardActions, CardContent,
	CardMedia, Grid, Grow, Typography
} from "@material-ui/core";
import appList from '../../assets/static/apps.json';

class MyApps extends Component {
	state = {
		showDescription: false
	};
	openApp = (link) => {
		window.open(link, '_blank');
	};
	toggleDescription = () => {
		this.setState({showDescription: !this.state.showDescription});
	};
	render() {
		let apps = appList.apps;
		return (
			<div className={classes.MyApps}>
				<Grid container spacing={4}>
					<Grid item xs={12}>
						<h2>Fun time coding😋</h2>
					</Grid>
					{apps.map((app, index) => (
						<Grow in={true} timeout={1000} key={index}>
							<Grid item xs={12} sm={6} md={4}>
								<div className={classes.HoverEffect} >
									<Card className={app.available ? classes.Card: classes.CardComingSoon}>
										<CardActionArea
											// onClick={(e) => this.openApp(app.link)}
										>
											<CardMedia
												component="img"
												alt={app.name}
												height="100"
												image={app.logo}
												title={app.name}
											/>
											<CardContent className={classes.CardContent}>
												<Typography gutterBottom variant="h6" component="h2">
													{app.name}
												</Typography>
												<Typography variant="body2" color="textSecondary" component="p">
													{app.description}
												</Typography>
											</CardContent>
										</CardActionArea>
										{
											app.available
												? <CardActions>
													<Button size="small" color="primary" onClick={(e) => this.openApp(app.link)}>
														Open
													</Button>
													<Button size="small" color="primary"
													        onClick={() => {navigator.clipboard.writeText(app.link)}}
													>
														Share
													</Button>
												</CardActions>
												: <CardActions>
													<Button size="small" color="primary" onClick={(e) => this.openApp(app.link)} disabled>
														Coming Soon...
													</Button>
												</CardActions>
										}
									</Card>
								</div>
							</Grid>
						</Grow>
					))}
				</Grid>
			</div>
		)
	}
}

export default MyApps;
